import { render, staticRenderFns } from "./InsightsSection.vue?vue&type=template&id=5c7da144&scoped=true"
import script from "./InsightsSection.vue?vue&type=script&lang=js"
export * from "./InsightsSection.vue?vue&type=script&lang=js"
import style0 from "./InsightsSection.vue?vue&type=style&index=0&id=5c7da144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7da144",
  null
  
)

export default component.exports